import MainTemplate from "../templates/MainTemplate";
import TiandyCameraServerListPage from "../pages/admin/camera/TiandyCameraServerListPage";
import {SettingOutlined, VideoCameraOutlined} from "@ant-design/icons";
import TiandyCameraServerEditPage from "../pages/admin/camera/TiandyCameraServerEditPage";
import CameraListPage from "../pages/admin/camera/CameraListPage";
import CameraEditPage from "../pages/admin/camera/CameraEditPage";
import SystemPropertyListPage from "../pages/admin/system/SystemPropertyListPage";
import SystemPropertyEditPage from "../pages/admin/system/SystemPropertyEditPage";
import SharedPropertyListPage from "../pages/admin/system/SharedPropertyListPage";
import SharedPropertyEditPage from "../pages/admin/system/SharedPropertyEditPage";
import UserListPage from "../pages/admin/user/UserListPage";
import UserEditPage from "../pages/admin/user/UserEditPage";
import LoginTemplate from "../templates/LoginTemplate";
import UserAccessEditPage from "../pages/admin/user/UserAccessEditPage";
import SystemOperationPage from "../pages/admin/system/SystemOperationPage";
import SystemLogPage from "../pages/admin/system/SystemLogPage";
import {commonRouters} from "./commonRouters";
import {privateOnlyRouters} from "./privateOnlyRouters";
import PuDashboardPage from "../pages/PuDashboardPage";
import SystemAuthListPage from "../pages/admin/system/SystemAuthListPage";
import SystemAuthEditPage from "../pages/admin/system/SystemAuthEditPage";
import VscsFlowHomePage from "../pages/camera/VscsFlowHomePage";
import VscsPersonTimelinePage from "../pages/camera/VscsPersonTimelinePage";
import VscsPersonFacePage from "../pages/camera/VscsPersonFacePage";
import VscsPersonFrequencyPage from "../pages/camera/VscsPersonFrequencyPage";
import VscsPersonMixPage from "../pages/camera/VscsPersonMixPage";
import VscsReligionVenueListPage from "../pages/camera/VscsReligionVenueListPage";
import VscsReligionVenuePage from "../pages/camera/VscsReligionVenuePage";
import VscsCamerasPage from "../pages/camera/VscsCamerasPage";
import NewsCenterPage from "../pages/news/NewsCenterPage";
import NewsPage from "../pages/news/NewsPage";
import VscsDailyReportPage from "../pages/camera/VscsDailyReportPage";

// 项目，非涉密 true，涉密 false
export const PRODUCT_IS_PUBLIC = true

export const routers = [
    {
        path: "/login",
        component: <LoginTemplate/>,
        children: [
            ...commonRouters.loginTemplateRouters
        ]
    },
    {
        path: "/",
        component: <MainTemplate/>,
        children: [
            {
                name: "总览",
                isPrivate: false,
                isPublic: true,
                path: '/',
                component: <PuDashboardPage/>
            },

            {
                name: "资讯中心",
                isPrivate: false,
                isPublic: true,
                path: '/news_center',
                component: <NewsCenterPage/>
            },
            {
                name: "资讯详情",
                isPrivate: false,
                isPublic: true,
                path: '/news',
                hidden: true,
                component: <NewsPage/>
            },

            {
                name: "场所一览",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/venues',
                component: <VscsReligionVenueListPage/>
            },
            {
                name: "场所详情",
                isPrivate: false,
                isPublic: true,
                hidden: true,
                path: '/vscs/venue',
                component: <VscsReligionVenuePage/>
            },
            {
                name: "流量总览",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/flow/statistics',
                component: <VscsFlowHomePage/>
            },

            {
                name: "安防矩阵",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/live',
                component: <VscsCamerasPage/>
            },
            {
                name: "安防日报",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/report/daily',
                component: <VscsDailyReportPage/>
            },
            {
                name: "人脸库",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/person/frequency',
                component: <VscsPersonFrequencyPage/>
            },
            // {
            //     name: "安防周报",
            //     isPrivate: false,
            //     isPublic: true,
            //     path: '/vscs/report/weekly',
            //     component: <VscsCamerasPage/>
            // },
            {
                name: "安防人物时间轴",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/person/timeline',
                hidden: true,
                component: <VscsPersonTimelinePage/>
            },
            {
                name: "安防人物",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/person/faces',
                hidden: true,
                component: <VscsPersonFacePage/>
            },
            {
                name: "安防人物合并",
                isPrivate: false,
                isPublic: true,
                path: '/vscs/person/mix',
                hidden: true,
                component: <VscsPersonMixPage/>
            },

            ...privateOnlyRouters.mainTemplateRouters,
            ...commonRouters.mainTemplateRouters,

            {
                name: "视频安防管理",
                icon: <VideoCameraOutlined/>,
                children: [
                    {
                        name: "TD安防服务器",
                        isPrivate: false,
                        isPublic: true,
                        path: '/camera_server/td',
                        auth: "camera_server",
                        component: <TiandyCameraServerListPage/>
                    },
                    {
                        name: "TD安防服务器编辑",
                        isPrivate: false,
                        isPublic: true,
                        path: '/camera_server/td/edit',
                        auth: "camera_server",
                        hidden: true,
                        component: <TiandyCameraServerEditPage/>
                    },
                    {
                        name: "摄像机管理",
                        isPrivate: false,
                        isPublic: true,
                        path: '/camera',
                        auth: "camera",
                        component: <CameraListPage/>
                    },
                    {
                        name: "摄像机编辑",
                        isPrivate: false,
                        isPublic: true,
                        path: '/camera/edit',
                        auth: "camera",
                        hidden: true,
                        component: <CameraEditPage/>
                    },
                ]
            },
            {
                name: "系统管理",
                icon: <SettingOutlined/>,
                children: [
                    {
                        name: "操作记录",
                        isPrivate: true,
                        isPublic: true,
                        path: '/system/operation',
                        auth: "system_operation",
                        component: <SystemOperationPage/>
                    },
                    {
                        name: "系统日志",
                        isPrivate: true,
                        isPublic: true,
                        path: '/system/log',
                        auth: "system_log",
                        component: <SystemLogPage/>
                    },
                    {
                        name: "系统属性管理",
                        isPrivate: true,
                        isPublic: true,
                        path: '/properties/system',
                        auth: "system_properties",
                        component: <SystemPropertyListPage/>
                    },
                    {
                        name: "系统属性编辑",
                        isPrivate: true,
                        isPublic: true,
                        path: '/properties/system/edit',
                        auth: "system_properties",
                        hidden: true,
                        component: <SystemPropertyEditPage/>
                    },
                    {
                        name: "集群属性管理",
                        isPrivate: true,
                        isPublic: true,
                        path: '/properties/shared',
                        auth: "shared_properties",
                        component: <SharedPropertyListPage/>
                    },
                    {
                        name: "集群属性编辑",
                        isPrivate: true,
                        isPublic: true,
                        path: '/properties/shared/edit',
                        auth: "shared_properties",
                        hidden: true,
                        component: <SharedPropertyEditPage/>
                    },
                    {
                        name: "集群授权管理",
                        isPrivate: true,
                        isPublic: true,
                        path: '/system/auth',
                        auth: "system_auth",
                        component: <SystemAuthListPage/>
                    },
                    {
                        name: "集群授权编辑",
                        isPrivate: true,
                        isPublic: true,
                        path: '/system/auth/edit',
                        auth: "system_auth",
                        hidden: true,
                        component: <SystemAuthEditPage/>
                    },
                    {
                        name: "用户管理",
                        isPrivate: true,
                        isPublic: true,
                        path: '/user',
                        auth: "user",
                        component: <UserListPage/>
                    },
                    {
                        name: "用户编辑",
                        isPrivate: true,
                        isPublic: true,
                        path: '/user/edit',
                        auth: "user",
                        hidden: true,
                        component: <UserEditPage/>
                    },
                    {
                        name: "用户访问控制",
                        isPrivate: true,
                        isPublic: true,
                        path: '/user/access/edit',
                        auth: "user",
                        hidden: true,
                        component: <UserAccessEditPage/>
                    },
                ]
            }
        ]
    },
]